import React, { useEffect, useRef, useState } from "react";
import { api } from "../../api";
import "./fi-extra.css";

/**
 * Searchable comparison chooser backed by the directory endpoint, so any
 * cached team/player can be compared, not just the first 100 names.
 */
export default function ComparePicker({ kind, value, onChange, exclude }) {
  const [query, setQuery] = useState("");
  const [rows, setRows] = useState([]);
  const names = useRef(new Map());

  useEffect(() => {
    let alive = true;
    const timer = setTimeout(() => {
      api
        .get(`/api/football/intelligence/directory/${kind}`, { params: { q: query, limit: 50 } })
        .then((response) => {
          if (!alive) return;
          const list = response.data.rows || [];
          list.forEach((row) => names.current.set(row.id, row.name));
          setRows(list);
        })
        .catch(() => {});
    }, query ? 250 : 0);
    return () => {
      alive = false;
      clearTimeout(timer);
    };
  }, [kind, query]);

  const options = rows.filter((row) => row.id !== exclude);
  const selectedMissing = value && !options.some((row) => row.id === value);

  return (
    <>
      <label>Find to compare
        <input type="search" aria-label="Search comparison" placeholder={`Search ${kind}s`} value={query} onChange={(e) => setQuery(e.target.value)} />
      </label>
      <label>Compare with
        <select aria-label="Compare entity" value={value} onChange={(e) => onChange(e.target.value)}>
          <option value="">No comparison</option>
          {selectedMissing && <option value={value}>{names.current.get(value) || value}</option>}
          {options.map((row) => <option key={row.id} value={row.id}>{row.name}</option>)}
        </select>
      </label>
    </>
  );
}
